import styled, { keyframes } from "styled-components";
import { colors, sizes } from "../../util";
import tile from "./pattern.png";

export const Wrapper = styled.div`
  max-width: 88rem;
  margin: 0 auto;
  @media (min-width: ${sizes.medium}) {
    // padding: 0 2rem;
  }
`;

export const GraphicWrapper = styled.div`
  background: #cbcbcb;
  & video {
    object-fit: cover;
  }
`;

export const Graphic = styled.div`
  background-image: url(${tile});
  background-size: 25rem;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  @media (min-width: ${sizes.medium}) {
    background-size: 35rem;
  }
`;

export const Warning = styled.div`
  margin: 0 1.5rem;
  padding: 1rem 0;
  border-bottom: 1px solid ${colors.grey};
  color: ${(props) => props.theme.color};
`;

export const LogoWrapper = styled.div`
  position: relative;
  margin: ${(props) => (props.top ? "1.5rem 0" : "-4rem 0")};
`;

export const MenuWrapper = styled.div`
  width: 100%;
  .menu {
    margin: 1rem 0 0 1.5rem;
    display: block;
    text-align: left;
    > li {
      display: inline-block;
      text-align: left;
      &:not(:last-child):after {
        content: "/";
        display: inline-block;
        padding: 0;
        font-size: 2rem !important;
        font-weight: 700;
        margin: 0 1.5rem;
        @media (min-width: ${sizes.small}) {
          font-size: 3rem !important;
        }
      }
      a {
        background: none !important;
        border: none !important;
        border-bottom: 1px ${(props) => props.theme.color} solid !important;
        display: inline !important;
        padding: 0;
        font-size: 2rem !important;
        font-weight: 700;
        color: ${(props) => props.theme.color};
        @media (min-width: ${sizes.small}) {
          font-size: 3rem !important;
        }
        &.active {
          color: black;
          border-bottom: none !important;
        }
        &:not(.active): hover {
          color: ${(props) => props.theme.color};
          opacity: 0.5;
        }
      }
    }
  }
`;

const rotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

export const MicaLogo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  svg {
    height: 100%;
    width: 100%;
  }
  svg path,
  svg polygon,
  svg polyline {
    transition: 0.25s;
    fill: ${(props) => props.theme.color};
  }
  @media (min-width: ${sizes.small}) {
    width: 50vw;
    height: 50vh;
  }
`;

export const Rotate = styled.img`
  background: ${(props) => props.theme.color};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 80vw;
  max-height: 80vh;
  padding: 1vw;
  animation: ${rotate} 24s linear infinite;
  @media (min-width: ${sizes.medium}) {
    max-width: 50vw;
    max-height: 70vh;
  }
`;

export const InlineRotate = styled.div`
  // border-radius: 50%;
  position: relative;
  // top: 2rem;
  // left: 2rem;
  width: 3rem;
  height: 3rem;
  // animation: ${rotate} 24s linear infinite;
  div {
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${(props) => props.theme.color};
    // mix-blend-mode: difference;
  }
  img {
    // filter: invert(1);
  }
`;

export const Bg = styled.div`
  background: rgba(255, 255, 255, 0.65);
  padding: 2rem 0;
  @media (min-width: ${sizes.medium}) {
    padding: 2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Home/styles.js